export default {
  pages: {
    bmlSearchClients: {
      title: 'Поиск клиента',
      dateOfBirth: 'Дата рождения',
      findClient: 'Найти клиента',
    },
  },
};
